import HelpMedia from "./HelpMedia";
import React from "react";

const HelpOverlay = () => {
  return (
    <div className="pt-3">
      <h3>Overlay Data (SAFE/RISK) Page</h3>
      <p>
        The Overlay Data page automates SAFE and RISK analysis, to identify regions of the HAP1 genetic interaction
        profile similarity network that are enriched for specific gene set(s) defined by the user.
      </p>

      <h5 className="mt-4">Key Features:</h5>
      <ul>
        <li>Semi-quantitative, visual representation of functions enriched among custom gene sets</li>
      </ul>

      <h5 className="mt-4">How to Use:</h5>
      <div className="mb-4">
        <h6 className="fw-semibold">1. Overlay Data</h6>
        <p>
          Clicking on the "Overlay Data" button on the TheCellMap.org home page opens a window where a user can
          upload one or more gene sets for SAFE analysis. Genes can be inputted individually or cut and paste from a
          different file. After clicking on the Run SAFE/RISK button, an outline of the HAP1 profile similarity network
          will appear in a new browser tab where regions of the HAP1 profile similarity network specifically enriched
          for genes from the input list are indicated by nodes colored according to the user selection. Network regions
          corresponding to biological processes that are significantly enriched for the input gene set are listed in
          the legend. The identity of network clusters corresponding to biological processes enriched for an input list
          are also highlighted by hovering over a network region or a term name in the legend and SAFE/RISK enrichment
          maps can be downloaded as a Portable Network Graphics (.png) file.
        </p>
        <HelpMedia
          src={`${process.env.PUBLIC_URL}/videos/help/safe_overlay_my_data.webm`}
          poster={`${process.env.PUBLIC_URL}/images/help/safe_overlay_my_data.png`}
          alt="Overlay My Data"
        />
      </div>
    </div>
  );
}

export default HelpOverlay;